const isProduction = process.env.NODE_ENV === "production";

const apiUrl = isProduction
	? process.env.REACT_APP_API
	: process.env.REACT_APP_API_LOCAL;
// const apiUrl = " https://cb22-2806-2f0-51e0-18e-751b-2839-e78b-f3d2.ngrok.io/api";

export default apiUrl;
